var map = {
	"./dec_tree.png": "R1wt",
	"./doodle_icon.png": "Q798",
	"./network-img.png": "MRV1",
	"./riley_sm.png": "K7dm",
	"./tooth.png": "uMaJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yATL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project_icons ^\.\/.*$
// module id = yATL
// module chunks = 1